import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditTimeOffRows, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { GridCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getExistingRow, getNewRow } from './TimeOffHours';

interface GridCellProps {
  [key: string]: any;
}

export const TimeOffPayerCell = (cellParams: GridCellParams) => {
  return <TimeOffPayer cellParams={cellParams} />;
};

const TimeOffPayer = React.memo(function TimeOffPayer(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const [timeOffPayer, setTimeOffPayer] = useState(cellParams?.cellParams?.row?.timeOffPayerDescription);
  const { control } = useFormContext();
  const isModEdit = useSelector(selectIsEditMod);
  const timeOffEditRequests = useSelector(selectEditTimeOffRows);

  const options = [
    {
      ID: 1,
      Description: 'No Per Diems to Traveler',
    },
    {
      ID: 2,
      Description: 'Traveler Direct Pay',
    },
    {
      ID: 3,
      Description: 'Facility Determined',
    },
    {
      ID: 4,
      Description: 'Make Up/Chargeable',
    },
    {
      ID: 5,
      Description: 'Subsidy Prorate',
    },
  ];
  const RowId = cellParams?.cellParams?.id;
  const setPayerForTimeOffEdit = data => {
    setTimeOffPayer(data);
    let newRow = timeOffEditRequests.slice(0);

    let timeOffEditRow = cellParams?.cellParams?.row?.placementTimeOffId
      ? getExistingRow(timeOffEditRequests, cellParams)
      : getNewRow(timeOffEditRequests, RowId);

    let updatePayer = {
      ...timeOffEditRow,
      timeOffPayerDescription: data,
      placementTimeOffPayerId: options.find(el => el.Description === data)?.ID,
    };

    let editDateIndex = timeOffEditRequests?.findIndex(
      cellParams?.cellParams?.row?.placementTimeOffId
        ? row => row.placementTimeOffId === updatePayer.placementTimeOffId
        : row => row.id === RowId,
    );
    newRow[editDateIndex] = updatePayer;
    dispatch(placementModsAction.setEditTimeOffRows(newRow));
    dispatch(placementModsAction.setGridModAltered(true));
  };

  return (
    <>
      <Controller
        name={`timeOffRequests${RowId}.Payer`}
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, ...rest } }) => (
          <FormInputDropdown
            name={'timeOffRequests.Payer'}
            require={true}
            standard={true}
            options={options ?? []}
            inputValue={timeOffPayer ?? null}
            readOnly={!isModEdit}
            handleChange={e => setPayerForTimeOffEdit(e.target.value)}
          ></FormInputDropdown>
        )}
      />
    </>
  );
});
